import React from "react";
import "./index.scss";

const InputField = ({
  icon,
  label,
  type = "text",
  placeholder,
  value,
  onChange,
  maxLength,
  error,
  ...props
}) => {
  return (
    <div className={`input-field ${error ? "has-error" : ""}`}>
      {label && (
        <label className="input-label">
          {icon && <span className="input-icon">{icon}</span>}
          {label}
        </label>
      )}
      <input
        type={type}
        className="input-control"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        maxLength={maxLength}
        {...props}
      />
      {error && <div className="input-error">{error}</div>}
    </div>
  );
};

export default InputField;
